<template>
    <div class="splitter-title" :style="{left:`${nivel*8}px`}" @contextmenu="$event => openMenu($event)">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <p
            v-bind="attrs"
            v-on="on"
          >{{ title }}</p>
        </template>
        <span :style="{fontSize: '10px'}">{{ title }}</span>
      </v-tooltip>
    </div>
</template>
  
<script>
  
  export default {
    name: "SplitterTitle",
    components: {
    },
    props:{
      title: {
        type: String
      },
      nivel: {
        type: Number
      },
      splitter: {
        type: Object
      }
    },
    methods: {
      openMenu(e){
        this.$emit('open-menu', e, this.splitter, this.nivel);
      }
    }
  };
</script>
<style scoped>
.splitter-title {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45px;
  height: 25px;
  position: absolute;
  border: .5px solid #4fa2b7;
  border-radius: 10px;
  background-color: white;
  padding: 0 3px;
  top: calc(50% - 12.5px);
}
.splitter-title p {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/SplittersInfo/SplitterTitle.vue